module.exports = __webpack_public_path__ + "static/countdown-aa54d3f9f242b4a7b18cb87053378b88.png";